import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Table, Button, Card, ListGroup, Image, Tab, Tabs } from "react-bootstrap";
import Topbar from '../../shared/components/Topbar';
import NavbarComp from '../../shared/components/Navbar';
import { useLocation, useNavigate } from "react-router-dom"
import { useAuth } from '../auth/hooks/useAuth';
import { useCarts } from '../products/hooks/useCart';
import NavbarBackComp from '../../shared/components/NavbarBack';
import { useOrder } from './hooks/useOrder';
import Swal from 'sweetalert2';
import HistoryTransactionsTabs from './components/HistoryTransactionsTabs';
import { GrTransaction } from 'react-icons/gr';

const HistoryTransactionsPage = () => {

  const navigate = useNavigate()

  const { validate, auth } = useAuth()

  const [user, setUser] = useState()
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleBack = () => {
    navigate(-1)
  }

  useEffect(() => {
    (async () => {
      const userData = await validate();
      setUser(userData);
    })();
    // setCartItems(user?.cart)
    validate();
  }, [validate]);

  const [key, setKey] = useState("cart");

  return (
    <Container fluid style={{
      backgroundColor: '#f0f0f0',// Make sure the path is correct
      backgroundPosition: 'top right', // Position the image at the top-right corner
      backgroundSize: 'auto', // Adjust the size of the background image
      height: '100vh', // Make the container take full height (optional)    
      overflowY: 'auto',
      overflowX: 'hidden',
    }}>
      <Container
        style={{
          backgroundColor: '#f0f0f0',// Make sure the path is correct
          backgroundPosition: 'top right', // Position the image at the top-right corner
          backgroundSize: 'auto', // Adjust the size of the background image
          maxWidth: '1200px',
          height: '100vh',
        }}>
        <NavbarBackComp
          expand="lg"
          sticky="top"
          handleBack={handleBack}
          user={user}
        />
        <Row className="pt-3"
          style={{
            backgroundColor: '#f0f0f0',// Make sure the path is correct
            backgroundPosition: 'top right', // Position the image at the top-right corner
            backgroundSize: 'auto', // Adjust the size of the background image
            height: '17%', // Make the container take full height (optional)
            paddingBottom: '10px'
          }}>

          <Container className='md justify-content-center'>
            <Tabs
              id="order-tabs"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3"
              fill
            >
              <Tab eventKey="cart" title={
                <span>
                  <GrTransaction size={20} style={{ marginRight: '5px' }} />
                  Transaction
                </span>} className='m-3'>
                <Row>
                  <HistoryTransactionsTabs />
                </Row>
              </Tab>
            </Tabs>

          </Container>

        </Row>
      </Container >
    </Container >
  );
};

export default HistoryTransactionsPage;
